import React from "react";

export function NotRegistrationPage() {
    return (
        <div className={"not_registration_page"}>
            <div>利用登録がされていません。</div>
        </div>
    );
}
